<template>
<div class="swiper-slide-inner">
    <div class="step">
        <p>STEP<span>08</span></p>
    </div>
    <div class="card">
        <div class="card-inner">

            <div class="question-wrap">
                <h3><span>ショップの紹介画像の登録</span></h3>
                <p>ヘッダーに入る画像を2枚登録できます。店舗の写真とロゴを登録してください。</p>
            </div>

            <!--item-->
            <div class="item-wrap">
                <div class="item form_text">

                    Cropper設置予定地

                </div>
            </div>
        </div>

        <div class="control-wrap">
            <button type="button" class="_left js-swiper-prev"><span>Back</span></button>
            <button type="button" class="_right js-swiper-next"><span>Next</span></button>
        </div>

    </div>
</div>
</template>

